import get from 'lodash/get';

import { GetSitesByOrgDocument } from '@marketmuse/data-papi';
import makeRequest from '../../utils/makeRequest';
import * as types from '../../config/types';

export default () => () => next => action => {
  if (action.type === types.GET_SITES_BY_ORG) {
    makeRequest({
      type: types.GET_SITES_BY_ORG,
      mutation: GetSitesByOrgDocument,
      variables: {
        id: action.id,
      },
      options: {
        isQuery: true,
      },
      apolloOptions: {
        fetchPolicy: 'no-cache',
      },
    }).then(res => {
      const org = get(res, 'organization') || {};
      if (action.callback) action.callback(org);
    });
  }

  return next(action);
};
